import Chart from 'chart.js/auto';
import { radarOptions, selfAssessmentData } from '../chart.js';

export default (solution, formData = null) => ({
  page: 0,
  answers: [],
  answer: null,
  minCorrect: [],
  changed(answer, solution = 0) {
    this.answers[this.page - 1] = {
      answer: answer,
      solution: !!solution,
      group: this.$el.dataset.group,
    };
  },

  getAnswer(index) {
    if (this.answers[index - 2]) {
      return this.answers[index - 2].answer;
    }
    return null;
  },

  prevPage() {
    this.page--;
    if (this.answers[this.page - 1]) {
      this.answer = this.answers[this.page - 1].answer;
    } else {
      this.answer = null;
    }
  },

  nextPage() {
    this.page++;
    if (this.answers[this.page - 1]) {
      this.answer = this.answers[this.page - 1].answer;
    } else {
      this.answer = null;
    }
  },

  lastPage() {
    this.page++;
    this.startGraph();
  },

  startGraph() {
    const labels = [...new Set(this.answers.map((item) => item.group))];
    const answers = [];
    this.answers.forEach((item) => {
      if (
        (item.answer === 'true') == item.solution ||
        !(item.answer === 'false') == item.solution
      ) {
        answers[labels.indexOf(item.group)]
          ? answers[labels.indexOf(item.group)]++
          : (answers[labels.indexOf(item.group)] = 1);
      } else {
        answers[labels.indexOf(item.group)]
          ? ''
          : (answers[labels.indexOf(item.group)] = 0);
      }
    });
    const elem = document.getElementById('myChart');
    if (elem) {
      const ctx = elem.getContext('2d');
      const myChart = new Chart(ctx, {
        type: 'radar',
        data: selfAssessmentData,
        options: radarOptions,
      });
      myChart.data.labels = labels;
      myChart.data.datasets[0].data = answers;
      myChart.data.datasets[1].data = this.solution;
      myChart.update();
    }
  },

  init() {
    this.solution = solution;
    if (formData) {
      this.answers = formData;
      this.startGraph();
    }
  },
});
